import { track } from '@/lib/analytics';

const sources = new Set(['support_email_redirect', 'noreply_email_redirect']);
let captured = false;

/** Capture the initial landing before a saved session navigates away from login. */
export function captureEmailRedirectArrival(): void {
  if (captured) return;
  const { pathname, search, hash } = window.location;
  if (hash || !['/login', '/app'].includes(pathname)) return;
  const params = new URLSearchParams(search);
  if (['code', 'token', 'token_hash', 'access_token', 'refresh_token', 'invite', 'admin_session']
    .some((key) => params.has(key))) return;
  const values = params.getAll('src');
  if (values.length !== 1 || !sources.has(values[0])) return;
  captured = true;
  // Only finite source/route labels. Never copy an email, query or link token.
  // URL markers attribute browser arrivals, not delivery or confirmed human clicks.
  track('portal_email_redirect_arrived', { source: values[0], entry_path: pathname });
}
